/** Resolve a relative API path against the probed base URL (handles leading-slash paths). */
export function resolveApiPath(baseUrl: string, url: string): string {
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  const normalizedBase = baseUrl.replace(/\/$/, '');
  if (!normalizedBase) {
    return url.startsWith('/') ? url : `/${url}`;
  }
  return url.startsWith('/') ? `${normalizedBase}${url}` : `${normalizedBase}/${url}`;
}

/** True when the URL is an absolute external target (e.g. presigned S3 upload). */
export function isAbsoluteExternalUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}
